import { defineStore } from "pinia";
import jwtDecode from "jwt-decode";
import { Role } from "~/types/user/Role";

export interface JwtResponse {
  iat: number;
  exp: number;
  roles: string[];
  username: string;
  uuid: string;
  name: string;
  email: string;
  userUuid: string;
}
export interface UserState {
  jwt: string | null;
  user: JwtResponse | null;
}

interface LoginResponse {
  token: string;
}

const expired = (user: JwtResponse | null): boolean => {
  return user === null || Date.now() >= user.exp * 1000;
};
export const useAuthStore = defineStore({
  id: "auth",
  persist: true,
  state: (): UserState => {
    return {
      jwt: null,
      user: null,
    };
  },
  actions: {
    async login(loginForm: { email: string; password: string }) {
      const config = useRuntimeConfig();
      await $fetch<LoginResponse>(config.public.apiBase + "/login", {
        method: "POST",
        body: loginForm,
      })
        .then((response) => {
          this.jwt = response.token;
          this.user = jwtDecode(this.jwt);
        })
        .catch((error) => {
          throw error;
        });
    },
    logout() {
      this.jwt = null;
      useRouter().push("/login");
    },
  },
  getters: {
    isLoggedIn: (state: UserState): boolean =>
      state.jwt !== null && !expired(state.user),
    getToken: (state: UserState): string | null => state.jwt ?? null,
    getUser: (state: UserState): JwtResponse | null =>
      state.user && !expired(state.user) ? state.user : null,
    isAdmin: (state: UserState): boolean =>
      state.user !== null ? state.user.roles.includes(Role.ROLE_ADMIN) : false,
    isSuperAdmin: (state: UserState): boolean =>
      state.user !== null
        ? state.user.roles.includes(Role.ROLE_SUPERADMIN)
        : false,
  },
});
